export default "__VITE_ASSET__DVkFDe1X__"